import { Component } from "react"
import Format from "src/utils/Format"
import ApiHandler from "src/api/ApiHandler"
import navigationService from "src/navigation/NavigationService"
import AddressThumbnail from "src/components/address_images/AddressThumbnail"
import "src/components/comparable_homes/ComparableHome.css"

interface RecentSaleCardProps {
    sale: any
    apiHandler: ApiHandler
    isHighlighted?: boolean
    onSelect?: () => void
    isGoogleBot: boolean
}

export default class RecentSaleCard extends Component<RecentSaleCardProps> {
    handleNavigate = async () => {
        const { sale, apiHandler } = this.props
        const propertyId = sale?.id ?? sale?.gi
        if (propertyId && apiHandler) {
            await navigationService.navigateToValuation(propertyId, apiHandler)
        }
    }

    render() {
        const { sale, apiHandler } = this.props
        const fullAddress = sale?.a ?? sale?.address ?? ""
        const displayAddress = sale?.da || fullAddress
        const isGoogleBot = this.props.isGoogleBot
        const sh = sale?.sh ?? {}
        const dates = typeof sh === "object" ? Object.keys(sh).sort() : []
        const latestSale = dates.length > 0 ? sh[dates[dates.length - 1]] : null
        const price = latestSale?.p?.v != null ? parseFloat(String(latestSale.p.v)) : null
        const saleDateRaw = latestSale?.d ?? (dates.length > 0 ? dates[dates.length - 1] : null)
        const saleDateFormatted = saleDateRaw
            ? (() => {
                  try {
                      const d = new Date(saleDateRaw)
                      return isNaN(d.getTime()) ? saleDateRaw : d.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" })
                  } catch {
                      return saleDateRaw
                  }
              })()
            : null

        const propertyId = sale?.id ?? sale?.gi
        const { isHighlighted, onSelect } = this.props
        const cardClassName = "comparable-home-card recent-sale-card" + (isHighlighted ? " highlighted" : "")

        return (
            <div
                className={cardClassName}
                onClick={() => onSelect?.()}
                role={onSelect ? "button" : undefined}
                tabIndex={onSelect ? 0 : undefined}
                onKeyDown={onSelect ? (e) => e.key === "Enter" && onSelect() : undefined}
            >
                <div className="card-layout">
                    {!isGoogleBot && propertyId && fullAddress && apiHandler && (
                        <AddressThumbnail
                            locationId={propertyId}
                            locationString={fullAddress}
                            apiHandler={apiHandler}
                        />
                    )}
                    <div className="card-body">
                        <div className="card-content">
                            <div className="address-row">
                                {propertyId && apiHandler && (
                                    <button
                                        className="view-button"
                                        onClick={(e) => {
                                            e.stopPropagation()
                                            this.handleNavigate()
                                        }}
                                        title="View this property's valuation"
                                        aria-label="View this property's valuation"
                                    >
                                        →
                                    </button>
                                )}
                                <div className="address-title">
                                    <span className="address-text">{displayAddress || "—"}</span>
                                </div>
                            </div>

                            <div className="financial-fields">
                                {price != null && (
                                    <div className="financial-field">
                                        <span className="info-label">Sale Price</span>
                                        <span className="info-value sale-price">
                                            {Format.getFormattedCurrency(price, "€")}
                                        </span>
                                    </div>
                                )}
                                {saleDateFormatted && (
                                    <div className="financial-field">
                                        <span className="info-label">Sale Date</span>
                                        <span className="info-value sale-date">{saleDateFormatted}</span>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
